import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

function ResetPasswordPage() {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password }),
            });

            if (response.ok) {
                setMessage('Пароль переустановлен успешно.');
            } else {
                const data = await response.json();
                setMessage(data.message || 'Ошибка при сбросе пароля.');
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('Возникла ошибка. Пожалуйста, попробуйте позже.');
        }
    };

    return (
        <div className="reset-password-form">
            <h2>Переустановить пароль</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="password"
                    placeholder="Новый пароль"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit">Заменить пароль</button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
}

export default ResetPasswordPage;
